export default __webpack_public_path__ + "static/media/moment-back.10ddf668.svg";